import React from 'react';

import { Grid } from '@material-ui/core';
import { TextField, DateField, Step } from '../SteppedForm';

import './index.css';

const StepInsurance = (props) => {
  return (
    <Step
      id="insurance"
      title="Vehicle Insurance"
      skip={(formdata) =>
        props.getVehicle().plate === '13cabs' ||
        formdata.onboardcar === false ||
        formdata.tiger === true ||
        formdata.vehicles[props.state.vehicle_index].carbuy ||
        (!formdata.vehicles[props.state.vehicle_index].carfin && !props.stateconfig().alwaysinsure)
      }>
      <Grid container>
        <Grid item xs={12} lg={9}>
          <TextField
            id="policynumber"
            modify={(value) => props.toUpperCase(value)}
            label="Policy Number"
            required={props.state.formdata.state ==='nt'}
          />
        </Grid>
        <Grid item xs={12} lg={3}>
          <DateField 
          id="policyexp" 
          label="Policy Expiry" 
          required={props.state.formdata.state === 'nt'}
          disablePast />
        </Grid>
      </Grid>
    </Step>
  );
};

export default StepInsurance;
